import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FeatureManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Feature Management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FeatureManagementHeader;
